<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name:"app",
        data(){
            return {

            }
        },
        components:{
            
        },
        mounted() {
            let html = document.getElementsByTagName("html")[0];
            this.reset(html)
            // window.onresize = () => {
            //     this.reset(html)
            // }
        },
        methods: {
            reset(html) {
                if (window.innerWidth * window.innerHeight <= 1920 * 1080) {
                    html.style.fontSize = (window.innerWidth * window.innerHeight) / 1920 / 1080 + "px";
                } else {
                    html.style.fontSize = (window.innerWidth * window.innerHeight) / 1920 / 1080 / 2 + "px";
                }
            },
            
        }, 
}
</script>


<style lang="less" >
    @import "./assets/css/global";
    @import "./assets/css/func";
    // #app{
    //     width: 100vw;
    //     height: 100vh;
    //     font-size: 100rem;
    // }
</style>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue